module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-3.9838ca64.mp3";